var React = require('react');

function Users (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#737680","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M15 23H1v-4.313c0-1.213.725-2.306 1.846-2.772 1.135-.47 2.824-.914 5.154-.914s4.019.444 5.154.915c1.121.465 1.846 1.558 1.846 2.771V23zM8 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zM23 11.836c0-.604-.265-1.179-.738-1.554C21.539 9.708 20.285 9 18.5 9s-3.039.708-3.762 1.282c-.473.375-.738.95-.738 1.554V13h9v-1.164zM18.5 6C19.88 6 21 4.88 21 3.5S19.88 1 18.5 1 16 2.12 16 3.5 17.12 6 18.5 6z"}));
}

Users.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = Users;

Users.default = Users;
